<template>
    <div>
        <VueMultiselect
            :placeholder="placeholder"
            :label="labelKey"
            track-by="id"
            :multiple="multiple"
            v-model="values"
            :taggable="taggable"
            @tag="addTag"
            @search-change="search"
            :options="formattedOptions"
            @select="chosen"
        />

        <template v-for="s in values" v-if="multiple">
            <input type="hidden" :name="s.input_name" :value="s.name">
        </template>

        <template v-if="! multiple && values">
            <input type="hidden" :name="name" :value="values.id">
        </template>
    </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect';

export default {
    name: "GenericMultiSelect",
    props: {
        placeholder: {
            default: 'Type to search',
        },
        options: {
            default: () => ([]),
        },
        selected: {
            default: () => ({}),
        },
        name: {
            type: String,
        },
        taggable: {
            default: false,
        },
        multiple: {
            default: true,
        },
        api: {
            default: null,
        },
        emitSelectedTo: {
            default: null,
        },
        labelKey: {
            default: 'name',
        },
        preload: {
            default: false,
        },
        limit: {
            default: 30,
        },
    },
    components: {
        VueMultiselect,
    },
    data() {
        return {
            values: [],
            apiOptions: [],
        }
    },
    computed: {
        formattedOptions() {
            if (this.api) {
                return this.apiOptions.map((d) => this.format(d));
            }

            return this.options.map((d) => this.format(d));
        },
    },
    created() {
        if (this.preload) {
            this.search('');
        }

        if (this.api && this.selected.length) {
            return this.populateApiValue();
        }

        // set the currently select values
        for (let id of Object.keys(this.selected)) {
            this.values.push(this.format({
                id,
                name: this.selected[id],
            }))
        }
    },
    methods: {
        chosen(option) {
            if (! this.emitSelectedTo) {
                return;
            }

            document.getElementById(this.emitSelectedTo).innerHTML = option.name;
            document.getElementById(this.emitSelectedTo).parentNode.classList.remove('hidden');
        },

        search(search) {
            if (! this.api) {
                return;
            }

            axios.get(this.api, {
                params: {
                    search,
                }
            }).then((r) => {
                this.apiOptions = r.data;
            });
        },
        populateApiValue() {
            axios.get(this.api, {
                params: {
                    id: this.selected,
                    limit: this.limit,
                }
            }).then((r) => {
                this.apiOptions = r.data;
                this.values = this.apiOptions.length ? this.apiOptions[0] : [];
            });
        },
        format(d) {
            d.input_name = `${this.name}[${d.id}]`;

            return d;
        },
        addTag (newTag) {
            const tag = {
                name: newTag,
                id: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            }

            this.options.push(tag)
            this.values.push(tag)
        }
    }
}
</script>

<style scoped>

</style>
